/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hero_Cta_ExploreInputs */

const en_directory_hero_cta_explore = /** @type {(inputs: Directory_Hero_Cta_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore tools`)
};

const zh_directory_hero_cta_explore = /** @type {(inputs: Directory_Hero_Cta_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索工具`)
};

/**
* | output |
* | --- |
* | "Explore tools" |
*
* @param {Directory_Hero_Cta_ExploreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hero_cta_explore = /** @type {((inputs?: Directory_Hero_Cta_ExploreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hero_Cta_ExploreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hero_cta_explore(inputs)
	return zh_directory_hero_cta_explore(inputs)
});
export { directory_hero_cta_explore as "directory.hero.cta_explore" }